import React from "react";
import useTranslate from "ui/locale/hooks/useTranslate";
import { LocaleTranslationResource } from "ui/locale/i18n.types";

interface TranslatedTextProps {
    textKey: string;
    values?: Record<string, React.ReactNode | string>;
    ns?: "translation" | "error";
    as?: keyof JSX.IntrinsicElements;
    className?: string;
    style?: React.CSSProperties;
}

const TranslatedText: React.FC<TranslatedTextProps> = ({
    textKey,
    values = {},
    ns,
    as: Tag = "span",
    className,
    style,
}) => {
    const translate = useTranslate(ns);

    const rawText = (translate(textKey as LocaleTranslationResource) as string) || textKey;

    const parts = rawText.split(/(\{\{.*?\}\})/g);

    return (
        <Tag className={className} style={style}>
            {parts.map((part: string, index: number) => {
                const match = part.match(/\{\{(.*?)\}\}/);
                if (match) {
                    const key = match[1].trim();
                    let value = values[key];

                    if (typeof value === "string") {
                        value = translate(value as LocaleTranslationResource) as string;
                    } else if (React.isValidElement(value)) {
                        const child = (value as React.ReactElement).props?.children;
                        if (typeof child === "string") {
                            const translatedChild = translate(child as LocaleTranslationResource) as string;
                            value = React.cloneElement(value, {}, translatedChild);
                        }
                    }

                    return <React.Fragment key={index}>{value ?? `{{${key}}}`}</React.Fragment>; // skipcq: JS-0437
                }
                return <React.Fragment key={index}>{part}</React.Fragment>; // skipcq: JS-0437
            })}
        </Tag>
    );
};

export default TranslatedText;